import { NextPage } from 'next'
import Image from 'next/legacy/image'

import StoreLayout from './../components/StoreLayout'
import { t } from '../../../utils'
import StoreProductTabs, {
  StoreItemTypeEnum
} from './components/StoreProductTabs'
import StoreProductsBanner from './components/StoreProductsBanner'

import patchesBannerImg from '@public/images/store/products_premium_patches_banner.png'
import patchesImg from '@public/images/store/product-patches.png'
import TryItBlock from '../components/TryItBlock'
import ProductsContent from './components/ProductsContent'

const StoreProductsPatches: NextPage & {
  theme?: string
} = () => {
  return (
    <StoreLayout
      pageTitle={t('Worship Keyboard Patches - Worship Online')}
      pageDescription={t(
        'Download premium keyboard patches that match the sounds of your favorite worship songs. Mainstage, Omnisphere, Kontakt'
      )}
    >
      <StoreProductsBanner title={t('Premium Patches')}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="92"
          height="88"
          viewBox="0 0 92 88"
        >
          <g>
            <g>
              <path
                fill="#fff"
                d="M45.918 6.01c.266 0 .75.08 1.021.633L56.976 26.98a7.179 7.179 0 0 0 5.407 3.927l22.445 3.263c.609.089.836.522.919.774.08.25.15.737-.288 1.166l-16.24 15.83a7.179 7.179 0 0 0-2.068 6.358l3.836 22.353c.102.608-.24.957-.454 1.114-.213.155-.654.37-1.196.084L49.258 71.294a7.19 7.19 0 0 0-6.682 0L22.5 81.852a1.1 1.1 0 0 1-1.197-.086c-.212-.157-.554-.506-.451-1.112l3.833-22.355c.401-2.331-.37-4.708-2.065-6.356L6.38 36.111a1.09 1.09 0 0 1-.289-1.166c.08-.252.31-.685.919-.774l22.444-3.263a7.172 7.172 0 0 0 5.406-3.927L44.9 6.643c.272-.552.755-.633 1.02-.633zM21.966 88.033c1.14 0 2.288-.276 3.348-.832l20.072-10.554c.33-.175.732-.175 1.062 0l20.075 10.552a7.134 7.134 0 0 0 7.562-.544 7.137 7.137 0 0 0 2.859-7.025l-3.836-22.353a1.142 1.142 0 0 1 .326-1.007l16.241-15.832a7.137 7.137 0 0 0 1.82-7.36 7.136 7.136 0 0 0-5.798-4.888l-22.444-3.262a1.136 1.136 0 0 1-.858-.622L52.358 3.968a7.138 7.138 0 0 0-6.44-4.001 7.14 7.14 0 0 0-6.44 4L29.44 24.307a1.136 1.136 0 0 1-.856.622L6.14 28.19a7.133 7.133 0 0 0-5.796 4.887 7.132 7.132 0 0 0 1.817 7.361l16.243 15.834c.266.26.389.637.324 1.003L14.895 79.63a7.128 7.128 0 0 0 2.858 7.023 7.148 7.148 0 0 0 4.213 1.38z"
              />
            </g>
          </g>
        </svg>
        <Image
          src={patchesBannerImg}
          alt={`Premium Patches background image`}
          priority={true}
          layout="fill"
          objectFit="cover"
        ></Image>
        <Image src={patchesImg} alt="premium patches products" />
      </StoreProductsBanner>
      <ProductsContent>
        <p>
          {t(
            `Keyboardists, express yourself in a way that you never have before. Imagine pressing your keys and hearing the most beautiful, inspiring synths, pads, and pianos you’ve ever heard. You’re only a few clicks away from that being your reality!`
          )}
        </p>
        <p>
          {t(
            `Our premium patches are built to sound identical to the keys parts from the album. Don’t waste hours trying to build synths and match sounds ever again. Get instant access to a library of patches, so you show up to rehearsal with the exact sounds you need.`
          )}
        </p>
      </ProductsContent>
      <StoreProductTabs tab={StoreItemTypeEnum.PremiumPatches} />
      <TryItBlock />
    </StoreLayout>
  )
}
StoreProductsPatches.theme = 'dark'
export default StoreProductsPatches
